// common
import clsx from "clsx";
import React from "react";

// Props Interface
interface Props {
  render: (text) => JSX.Element,
  text: string,
}

const initiallyRunning = true;
const postFix = '.';

const LoadingText: React.FunctionComponent<Props> = (props) => {
  const [count, setCount] = React.useState(1);
  const [running, setRunning] = React.useState(initiallyRunning);
  
  const interval = (delay = 0) =>  /** @param {() => void} callback */ (callback) => React.useEffect(() => {
    const id = setInterval(callback, delay);

    return () => clearInterval(id);
  }, [callback]);
  const use1Second = interval(1000);


  const tick = React.useCallback(() => (running ? setCount((count) => {
      if (count === 5)
        return 1;
      return count + 1;
    }) : undefined),
    [running]
  );
  use1Second(tick);

  return props.render(`${props.text}${postFix.repeat(count)}`);
};

export default LoadingText;
